import React, { Component } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import newfolderIcon from '../../images/new-folder-icon_active.png';
import clearIcon from '../../images/clear-field-icon.png';
import saveIcon from '../../images/save-to-cloud-icon_white.png';
import { PERSONA_FOLDER_NAME_EXCEED_WARNING } from '../../messages/messages';

class SaveDefinitionLabelPopupScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFolder: '',
      folderNameFromTextBox: '',
      selectedFolderObject: {},
      showNewFolderOption: false,
      definitionTree: _.clone(this.props.definitionTree).filter(def => def.scope === 4),
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.definitionTree !== this.props.definitionTree) {
      this.setState({
        definitionTree: _.clone(this.props.definitionTree).filter(def => def.scope === 4),
      });
    }
  }
  handleChange = selectedOption => {
    this.setState({
      selectedFolder: selectedOption.value,
      selectedFolderObject: selectedOption,
      showNewFolderOption: false,
      folderNameFromTextBox: '',
    });
  };

  dropdownOptions = () => (
    [
      ...this.state.definitionTree.map(folder => ({
        label: folder.folderName,
        value: folder.folderName,
        title: folder.folderName,
        object: { ...folder },
      })),
    ]
  );

  clearFolderVal = () => {
    this.setState({
      folderNameFromTextBox: '',
    });
  };

  onNewFolderOptionClick = () => {
    this.setState({
      selectedFolder: '',
      selectedFolderObject: {},
      showNewFolderOption: true,
    });
  };

  onTextBoxChange = e => {
    this.setState({
      folderNameFromTextBox: e.target.value,
    });
  };

  onSaveButtonClick = () => {
    const submitObject = {
      definitionFolderId: !_.isEmpty(this.state.selectedFolderObject)
        ? this.state.selectedFolderObject.object.definitionId
        : null,
      definitionFolderName: !_.isEmpty(this.state.selectedFolderObject)
        ? this.state.selectedFolderObject.object.folderName
        : this.state.folderNameFromTextBox,
    };

    this.props.onPersonaHeaderLabelSave(submitObject);
  };
  render() {
    const { personaHeaderLabelUpdateObject } = this.props;
    return (
      <div className="">
        <div className="large-12 medium-12 small-12 columns">
          <div className="large-10 medium-10 small-10 columns savePersonaPopup">
            <Select
              name="form-field-name"
              clearable={false}
              searchable={false}
              options={this.dropdownOptions()}
              onChange={val => this.handleChange(val)}
              value={this.state.selectedFolder}
              placeholder="Select Folder"
            />
          </div>
          <div className="large-2 medium-2 small-2 columns">
            <button type="button" onClick={() => this.onNewFolderOptionClick()}>
              <img
                className="insight360_persona_new_def_folder"
                src={newfolderIcon}
                alt="New Folder"
                title="Create New Folder"
              />
            </button>
          </div>
        </div>

        {this.state.showNewFolderOption && (
          <div
            className="large-12 medium-12 small-12 columns"
            style={{ marginTop: '2%' }}
          >
            <div className="large-10 medium-10 small-10 columns insight360_explorer_new_folder_name_Container">
              <div className="insight360_explorer_new_folder_name_Content">
                <input
                  type="text"
                  placeholder="Folder Name"
                  value={this.state.folderNameFromTextBox}
                  onChange={this.onTextBoxChange}
                  maxLength={60}
                />
                {this.state.folderNameFromTextBox.length > 0 && (
                  <span className="insight360_explorer_new_folder_name_btn">
                    <button type="button" onClick={this.clearFolderVal}>
                      <img
                        className="clear_icons_img"
                        src={clearIcon}
                        alt="clear"
                        title="clear"
                      />
                    </button>
                  </span>
                )}
              </div>
              <span style={{ float: 'right', color: '#4e0e28' }}>
                {`*${PERSONA_FOLDER_NAME_EXCEED_WARNING}`}
              </span>
            </div>
          </div>
        )}

        <div
          className="large-12 medium-12 small-12 columns"
          style={{ marginTop: '2%', marginBottom: '1%' }}
        >
          <div className="large-10 medium-10 small-10 columns">
            <div className="">
              <input
                type="text"
                value={personaHeaderLabelUpdateObject.expressions[0].title}
                readOnly
              />
            </div>
          </div>
        </div>
        <div
          className="large-12 medium-12 small-12 columns"
          style={{ marginTop: '2%', marginBottom: '1%' }}
        >
          <div className="columns large-offset-9 medium-offset-9 small-offset-9 large-3 medium-3 small-3">
            <div className="">
              <button
                className={`${
                  this.state.folderNameFromTextBox.length === 0 &&
                  _.isEmpty(this.state.selectedFolderObject)
                    ? 'explorer_new_folde-inactive'
                    : 'explorer_new_folde-active'
                }`}
                disabled={
                  this.state.folderNameFromTextBox.length === 0 &&
                  _.isEmpty(this.state.selectedFolderObject)
                }
                onClick={() => this.onSaveButtonClick()}
              >
                <span>
                  <img
                    className="save_icons_img"
                    src={saveIcon}
                    alt="save"
                    title="save"
                  />
                </span>{' '}
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaveDefinitionLabelPopupScreen;
